module.exports = __webpack_public_path__ + "img/GR125.f055b605.png";